import React from "react";
import { IconButton } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import theme from "../../theme/main";

const DiscordIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 255.995 255.995"
    >
      <path
        fill="#D5DBDE"
        strokeMiterlimit="10"
        d="M25.12 6.946c-2.424-1.948-6.257-2.278-6.419-2.292a.608.608 0 00-.604.357c-.004.008-.218.629-.425 1.228 2.817.493 4.731 1.587 4.833 1.647A.999.999 0 0122 9.75a.99.99 0 01-.501-.135C21.471 9.598 18.663 8 15.002 8 11.34 8 8.531 9.599 8.503 9.615a1 1 0 01-1.006-1.729c.102-.06 2.023-1.158 4.848-1.65-.218-.606-.438-1.217-.442-1.225a.6.6 0 00-.604-.357c-.162.013-3.995.343-6.451 2.318C3.564 8.158 1 15.092 1 21.087a.6.6 0 00.08.301c1.771 3.11 6.599 3.924 7.699 3.959a.61.61 0 00.511-.249l1.19-1.612c-2.61-.629-3.99-1.618-4.073-1.679a1 1 0 011.181-1.614C7.625 20.217 10.172 22 15 22c4.847 0 7.387-1.79 7.412-1.808a1.001 1.001 0 011.183 1.613c-.083.061-1.456 1.048-4.06 1.677l1.175 1.615c.115.158.298.25.492.25l.019-.001c1.101-.035 5.929-.849 7.699-3.959a.6.6 0 00.08-.301c0-5.994-2.564-12.928-3.88-14.14zM11 19c-1.105 0-2-1.119-2-2.5s.895-2.5 2-2.5 2 1.119 2 2.5-.895 2.5-2 2.5zm8 0c-1.105 0-2-1.119-2-2.5s.895-2.5 2-2.5 2 1.119 2 2.5-.895 2.5-2 2.5z"
        fontFamily="none"
        fontSize="none"
        fontWeight="none"
        textAnchor="none"
        transform="scale(8.53333)"
      ></path>
    </svg>
  );
};

const Socials = ({ social, link, linkTitle, buttonTitle }) => {
  let socialIcon = <GitHubIcon />;
  if (social === "linkedin") socialIcon = <LinkedInIcon />;
  else if (social === "email") socialIcon = <EmailIcon />;
  else if (social === "discord") socialIcon = <DiscordIcon />;
  else if (social === "facebook") socialIcon = <FacebookIcon />;

  return (
    <a
      href={link}
      target={social !== "email" ? "_blank" : "_self"}
      rel="noreferrer"
      title={linkTitle}
    >
      <IconButton
        sx={{ color: theme.palette.text.primary }}
        title={buttonTitle}
      >
        {socialIcon}
      </IconButton>
    </a>
  );
};

export default Socials;
